import useSVG from "../../hooks/useSVG";

function ProgramEquipments({ selectedProgram }) {
    const { UseEssentialsSVG } = useSVG();

    return (
        <div id="whats-needed" className="detail-whats-needed">
            <h5>NICE TO HAVE, BUT NOT REQUIRED:</h5>
            <div className="item-need-wrap">

                {
                    selectedProgram?.essentials.map((ess) => {

                        let icon = ess.icon.split("\\")[1]

                        return (
                            <div className="item-need">
                                <div className="image-part">
                                    {UseEssentialsSVG(ess?.svg)}
                                    {/* <img src={`https://api.indimoves.com/icons/${icon}`} className="star" style={{ width: "28px", height: "28px" }} /> */}
                                </div>
                                <body>{ess.title}</body>
                            </div>
                        )
                    })
                }

            </div>
        </div>
    );
}

export default ProgramEquipments;